import englishLabels from "./english_options";
import estonianLabels from "./estonian_options";
import finnishLabels from "./finnish_options";
import frenchLabels from "./french_options";
import germanLabels from "./german_options";
import norwegianLabels from "./norwegian_options";
import swedishLabels from "./swedish_options";
import italianLabels from "./italian_options";
import latvianLabels from "./latvian_options";
import hungarianLabels from "./hungarian_options";
import dutchLabels from "./dutch_options";
import danishLabels from "./danish_options";
import lithuanianLabels from "./lithuanian_options";
import croatianLabels from "./croatian_options";
import romanianLabels from "./romanian_options";
import greekLabels from "./greek_options";
import czechLabels from "./czech_options";
import polishLabels from "./polish_options";
import malteseLabels from "./maltese_options";
import spanishLabels from "./spanish_options";
import slovenianLabels from "./slovenian_options";
import bulgarianLabels from "./bulgarian_options";
import slovakLabels from "./slovak_options";
import portugueseLabels from "./portuguese_options";
import irishLabels from "./irish_options";
import icelandicLabels from "./icelandic_options";
export var languageOptions = {
  en_US: englishLabels,
  en_IE: englishLabels,
  en_LU: englishLabels,
  et_EE: estonianLabels,
  fi_FI: finnishLabels,
  de_DE: germanLabels,
  de_AT: germanLabels,
  sv_SE: swedishLabels,
  nb_NO: norwegianLabels,
  fr_FR: frenchLabels,
  fr_BE: frenchLabels,
  it_IT: italianLabels,
  lv_LV: latvianLabels,
  hu_HU: hungarianLabels,
  nl_NL: dutchLabels,
  nl_BE: dutchLabels,
  da_DK: danishLabels,
  lt_LT: lithuanianLabels,
  hr_HR: croatianLabels,
  ro_RO: romanianLabels,
  el_GR: greekLabels,
  cs_CZ: czechLabels,
  pl_PL: polishLabels,
  mt_MT: malteseLabels,
  es_ES: spanishLabels,
  sl_SL: slovenianLabels,
  bg_BG: bulgarianLabels,
  sk_SK: slovakLabels,
  pt_PT: portugueseLabels,
  ga_IE: irishLabels,
  is_IS: icelandicLabels
};